var map = {
	"./bg.png": 5878,
	"./icon_fb.png": 3375,
	"./icon_fb.webp": 147,
	"./icon_switch.png": 3082,
	"./icon_switch.webp": 618,
	"./icon_twitter.png": 6006,
	"./icon_twitter.webp": 6912,
	"./limited.png": 6964,
	"./logo_alti.png": 5252,
	"./logo_mebius.png": 3978,
	"./logo_mebius.webp": 7639,
	"./logo_shanon.png": 9258,
	"./logo_shanon.webp": 9707,
	"./shareimg.png": 3402,
	"./store_amazon.png": 4856,
	"./store_nowprinting.png": 2881,
	"./storeamiami.png": 6334,
	"./storebeep.png": 7923,
	"./storemario.png": 9101,
	"./titlelogo.png": 9849
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7173;